import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'

export const SealPrefectures = {
  namespaced: true,
  state: {
    collection: []
   },
  getters: {
    collection: state => state.collection
  },
  mutations: {
    UPDATE_COLLECTION(state, payload) {
      state.collection = payload['collection']
    }
  },
  actions: {
    /**
     * 獲得済みシール一覧（都道府県ごとにグルーピング、１店舗につき最初に獲得した１枚飲み含む）
     *
     * @param {*} param0
     * @param {*} payload
     */
    async actionFetchSealPrefectures({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      let res = null
      if (token !== '') {
        res = await APIClient.getSealCollection(token, accTime, userId)
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        console.log('collection',res.data.data)
        commit('UPDATE_COLLECTION', res.data.data)
      } else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    }
  }
}
